// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"13e7c6af","100":"a985207b","284":"b209e5d7","791":"c46ded26","839":"e3aa8b0b","863":"70ad3a80","979":"381bb782"}[chunkId] + ".chunk.js";
};